function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "",
    height: "800px",
    width: "800px",
    id: "Icons",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeOpacity: 1,
      strokeWidth: 0.08,
      strokeDasharray: "none",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 13,11 c 0.6,0 1,-0.4 1,-1 0,-0.6 -0.4,-1 -1,-1 -5,0 -9,4 -9,9 0,2.8 2.2,5 5,5 2.8,0 5,-2.2 5,-5 C 14,15.2 11.8,13 9,13 8.4449566,13 8.587661,12.47297 9.4809069,11.947307 10.506158,11.343961 11.688586,11 13,11 Z",
    id: "path1",
    style: {
      fill: "",
      fillOpacity: 1,
      strokeOpacity: 1,
      strokeWidth: 0.08,
      strokeDasharray: "none",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23,13 C 22.444957,13 22.696062,12.349102 23.779551,11.781287 24.733656,11.281277 25.814089,11 27,11 c 0.6,0 1,-0.4 1,-1 0,-0.6 -0.4,-1 -1,-1 -5,0 -9,4 -9,9 0,2.8 2.2,5 5,5 2.8,0 5,-2.2 5,-5 0,-2.8 -2.2,-5 -5,-5 z",
    id: "path2",
    style: {
      fill: "",
      fillOpacity: 1,
      strokeOpacity: 1,
      strokeWidth: 0.08,
      strokeDasharray: "none",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.260b644d431c593ab62750c10ca3a304.svg";
export { ForwardRef as ReactComponent };